import { ref } from "vue";
import { getMyProduct } from "@/service/canvas";
import { TASK_STATUS } from "@/common/constant";

export default () => {
  const history = ref([]);
  const loading = ref(false);
  const finish = ref(false);
  const active = ref(0);
  let pageIndex = 1;

  function getHistory(page = pageIndex) {
    loading.value = true;
    return getMyProduct({ page })
      .then(async (res) => {
        if (!res.errno) {
          // 第一页直接覆盖
          if (page === 1) {
            history.value = res.data.data;
            // 自动切换active为0
            active.value = 0;
          } else {
            history.value.push(...res.data.data);
          }
          if (history.value.length === 0) {
            history.value = [
              {
                code: TASK_STATUS.SUCCESS,
                img: "https://baga-1317914855.cos.ap-chongqing.myqcloud.com/tishiimg/kaishi.png",
                renwu_id: -1,
              },
            ];
          }
          const { current_page, last_page } = res.data;
          if (current_page === last_page) {
            finish.value = true;
          } else {
            pageIndex += 1;
          }
        }
      })
      .finally(() => {
        loading.value = false;
      });
  }
  return {
    history,
    loading,
    finish,
    active,
    getHistory,
  };
};
